import { useState } from 'react'

import { useUnsafeCallback } from 'modules/core/hooks/useCallback'
import { useUnsafeEffect } from 'modules/core/hooks/useEffect'
import hasFeature from 'modules/core/lib/hasFeature'

import { Shift, View } from 'modules/shift_management/lib/types'

import SwapShifts from '../store/internal/collections/SwapShifts'
import { useSwapShifts } from './useSwapShifts'

// TODO: Remove this hook once 'dev_shift_management_graphql_migration' is done
const useFetchSwapShifts = (shifts: Shift[], view: View) => {
  const newGraphQLVersion = hasFeature('dev_shift_management_graphql_migration')
  const shiftIds = shifts.map((shift) => shift.id)
  const { loading, swapShiftsCollection, refetch } = useSwapShifts({
    variables: { shiftIds },
    skip: !shiftIds.length || newGraphQLVersion,
  })

  const [swapShifts] = useState(swapShiftsCollection)

  const refreshSwapShifts = useUnsafeCallback(async () => {
    if (!shiftIds.length) return

    const { data } = await refetch()
    const newSwapShifts = SwapShifts.buildFromRequestOld(
      data ? data.shiftManagement.swapShiftsConnection.nodes : []
    )

    const shiftsToQuery = new Set(shiftIds)
    const otherSwapShifts = swapShifts.models.filter(
      (sw) => !shiftsToQuery.has(sw.currentShiftId) || !shiftsToQuery.has(sw.requestedShiftId)
    )

    swapShifts.reset([...otherSwapShifts, ...newSwapShifts.models])
  }, [swapShifts, refetch, shiftIds])

  useUnsafeEffect(() => {
    if (newGraphQLVersion) return
    refreshSwapShifts()
  }, [refetch, shifts]) // eslint-disable-line react-hooks/exhaustive-deps

  useUnsafeEffect(() => {
    swapShifts.reset([])
  }, [view]) // eslint-disable-line react-hooks/exhaustive-deps

  return { loading, swapShifts }
}

export default useFetchSwapShifts
